import { inOutQuintic } from './easing';

export const getScrollTop = () => document.documentElement.scrollTop
   || document.body.parentNode.scrollTop || document.body.scrollTop;

export const scrollTo = (to, duration) => {
  // SOURCE: https://gist.github.com/james2doyle/5694700, cleaned & removed callback
  // because it's so fucking difficult to detect the scrolling element, just move them all [sic]
  const move = (amount) => {
    document.documentElement.scrollTop = amount;
    document.body.parentNode.scrollTop = amount;
    document.body.scrollTop = amount;
  };

  const start = getScrollTop();
  const change = to - start;
  let currentTime = 0;
  const increment = 20;
  const animationDuration = (typeof duration === 'undefined') ? 500 : duration;
  const animateScroll = () => {
    // increment the time
    currentTime += increment;
    // find the value with the quintic in-out easing function (https://easings.net/#easeInOutQuint)
    const val = inOutQuintic(currentTime, start, change, animationDuration);
    // move the document.body
    move(val);
    // do the animation unless its over
    if (currentTime < animationDuration) {
      window.requestAnimationFrame(animateScroll);
    }
  };
  window.requestAnimationFrame(animateScroll);
};
